import React from "react"

import {ProductDriver} from "../../app/common/products/ProductStore"
import {Section} from "../../app/section/models/Section"
import HelperService from "../../services/HelperService"
import {Answer, IItem, ItemContentTypeEnum, ItemFormatEnum, TLocalAnswer} from "../../types/types"
import Button from "../Button/Button"

interface ItemMenuState {
    localAnswer: TLocalAnswer | null
}

interface ItemMenuProps {
    section: Section
    itemIndex: number
    handleNavigationByIndex: (index: number) => void
    localAnswer: TLocalAnswer | null
    driver: ProductDriver
}

export default class ItemMenuContainer extends React.Component<ItemMenuProps, ItemMenuState> {
    constructor(props: ItemMenuProps) {
        super(props)
        this.state = {
            localAnswer: null
        }
    }

    componentDidUpdate() {
        if (this.state.localAnswer !== this.props.localAnswer) {
            this.setState({localAnswer: this.props.localAnswer})
        }
    }

    openItem = (index: number) => {
        this.props.handleNavigationByIndex(index)
    }

    renderMenuItem = (item: IItem, itemIndex: number) => {
        const section: Section = this.props.section
        const itemId: number = item.id
        const binName: string = item.binName
        const itemName: string = item.name
        const answer: Answer | undefined = section.responses.get(`${itemId}${binName}`)
        const circleClass = "circle-xs " + HelperService.getAnswerStatusClassName(section, answer)

        let menuItemTitle: string = "Question"
        if (section.config.videoOnlyItems && item.format === ItemFormatEnum.BLANK) {
            if (
                (item.itemContent1 !== undefined && item.itemContent1.type === ItemContentTypeEnum.VIDEO) ||
                (item.itemContent2 !== undefined && item.itemContent2.type === ItemContentTypeEnum.VIDEO) ||
                (item.itemContent3 !== undefined && item.itemContent3.type === ItemContentTypeEnum.VIDEO) ||
                (item.itemContent4 !== undefined && item.itemContent4.type === ItemContentTypeEnum.VIDEO)
            ) {
                menuItemTitle = "Video"
            } else if (item.itemContent1 && item.itemContent1.type === ItemContentTypeEnum.PDF) {
                menuItemTitle = "Work Sheet"
            }
        }

        const isActive = itemIndex === this.props.itemIndex;

        const buttonStyle: React.CSSProperties = {
            border: "1px solid #CDCDCD",
            borderRadius: "1px",
            backgroundColor: isActive ? "#D8D8D8" : "#FFFFFF",
            padding: "6px",
            marginBottom: "6px",
            color: "#3B3832",
            fontSize: "12px",
            fontFamily: '"Helvetica Neue", sans-serif',
            lineHeight: "12px",
        };

        const textStyle: React.CSSProperties = {
            display: "inline-block",
        };

        const answerStatusClass = HelperService.getAnswerStatusClassName(section, answer);
        // const isActive = itemIndex === this.props.itemIndex;

        let circleBorderColor = isActive ? "#FFFFFF" : "#CDCDCD";
        let circleBackgroundColor = "inherit";

        if (answerStatusClass === "incorrect") {
            circleBorderColor = "rgb(231, 76, 60)";
            circleBackgroundColor = "rgb(231, 76, 60)";
        } else if (answerStatusClass === "correct") {
            circleBorderColor = "#1abc9c";
            circleBackgroundColor = "#1abc9c";
        } else if (answerStatusClass === "no") {
            circleBorderColor = "#cdcdcd";
            circleBackgroundColor = "#cdcdcd";
        }

        const circleStyle: React.CSSProperties = {
            border: `1px solid ${circleBorderColor}`,
            marginLeft: "22px",
            position: "relative",
            top: "1px",
            backgroundColor: circleBackgroundColor,
        };

        return (
            <div key={"button-"+itemName} id={"button-"+itemName}>
                <Button
                    block
                    onClick={() => this.openItem(itemIndex)}
                    style={buttonStyle}
                    testId={`menu-button-${itemIndex}`}
                >
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "80%" }}>
                        <span style={textStyle}>
                          {`${menuItemTitle} ${itemIndex + 1}`}
                        </span>
                        <span className={circleClass} style={circleStyle} />
                    </div>
                </Button>
            </div>
        )
    }

    render() {
        const items: IItem[] = this.props.section.items
        const indexBreak = items.length > 12 ? Math.ceil(items.length / 2) : items.length
        return (
            <>
                {items.length - 1 >= indexBreak ? (
                    <div className="item-menu__container item-menu__container--columns" style={{ height: "100%" }}>
                        <div style={{width:"100%"}}>
                            {items.map((item: IItem, itemIndex: number) => {
                                    return this.renderMenuItem(item, itemIndex)
                            })}
                        </div>
                    </div>
                ) : (
                    <div className="item-menu__container" style={{ height: "100%" }}>
                        {items.map((item: IItem, itemIndex: number) => {
                            return this.renderMenuItem(item, itemIndex)
                        })}
                    </div>
                )}
            </>
        )
    }
}

